var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container login" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-9 col-md-7 col-lg-5 mx-auto" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "card card-signin my-5" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h5", { staticClass: "card-title text-center" }, [
              _vm._v("Sign In")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.error,
                    expression: "error"
                  }
                ],
                staticClass: "alert alert-danger"
              },
              [_vm._v(_vm._s(_vm.error))]
            ),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "form-signin",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.login.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "form-label-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "inputEmail",
                      autocomplete: "username",
                      placeholder: "Email address",
                      name: "username",
                      required: "",
                      autofocus: ""
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "inputEmail" } }, [
                    _vm._v("Email address")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-label-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "password",
                      id: "inputPassword",
                      placeholder: "Password",
                      required: "",
                      name: "password"
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "inputPassword" } }, [
                    _vm._v("Password")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-lg btn-primary btn-block text-uppercase",
                    attrs: { type: "submit" }
                  },
                  [_vm._v("Sign in")]
                ),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-lg btn-text btn-block text-uppercase",
                    attrs: { to: "/forgot-password" }
                  },
                  [_vm._v("Forgot Password?")]
                )
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", { attrs: { src: require("@/csmworkflow/img/logo.svg") } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }